/* Free Life Labs — premium header behaviour (PREVIEW).
   Desktop, hover-capable pointers only: dropdowns open on hover (100 ms) and close after 250 ms.
   Only one open at a time. Click, keyboard (Enter/Space on summary), focus and Escape keep working. */
(function () {
  if (window.__fllHp) return; window.__fllHp = true;
  var root = document.documentElement;
  var OPEN_DELAY = 100, CLOSE_DELAY = 250;
  var hoverMQ = window.matchMedia('(hover: hover) and (pointer: fine)');
  var deskMQ = window.matchMedia('(min-width: 990px)');
  function canHover() { return hoverMQ.matches && deskMQ.matches; }

  /* translucent header once scrolled */
  function onScroll() { root.classList.toggle('fll-hp-scrolled', (window.scrollY || 0) > 8); }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  var ME = document.currentScript && document.currentScript.src;

  /* Products panel: tag each category column so it uses the site's category palette */
  var pnl = document.getElementById('fll-mega-v2');
  if (pnl) {
    var cols = pnl.querySelectorAll('.fll-mega__col');
    for (var ci = 0; ci < cols.length; ci++) {
      var tt = cols[ci].querySelector('.fll-mega__title');
      var t = ((tt && tt.textContent) || '').toLowerCase();
      var area = /nerve/.test(t) ? 'nerve' : /skin|derm/.test(t) ? 'skin' : /wound/.test(t) ? 'wound' : /glp/.test(t) ? 'glp' : '';
      if (area) cols[ci].setAttribute('data-area', area);
    }
    /* Derm 42 thumbnail: swap to the homepage's jar-with-brush image (same asset folder as this script) */
    if (ME) {
      var base = ME.split('?')[0].replace(/[^\/]+$/, '');
      var imgs = pnl.querySelectorAll('img.fll-mega__img');
      for (var ii = 0; ii < imgs.length; ii++) {
        if (!/Derm1\.png/i.test(imgs[ii].getAttribute('src') || '')) continue;
        imgs[ii].srcset = base + 'fll-zen-dm-450.webp 450w, ' + base + 'fll-zen-dm-900.webp 900w';
        imgs[ii].sizes = '84px';
        imgs[ii].src = base + 'fll-zen-dm-450.webp';
        imgs[ii].classList.add('fll-hp-dm');
      }
    }
  }

  var header = document.querySelector('.header-wrapper');
  var nav = document.querySelector('.header__inline-menu');
  if (!nav || !header) return;
  var panel = document.getElementById('fll-mega-v2');

  var items = [];
  var lis = nav.querySelectorAll('.list-menu--inline > li');
  for (var i = 0; i < lis.length; i++) {
    var d = lis[i].querySelector(':scope > header-menu > details');
    if (!d) continue;
    var s = d.querySelector(':scope > summary');
    var isProducts = !!panel && (s.textContent || '').trim().toLowerCase() === 'products';
    s.setAttribute('aria-haspopup', 'true');
    s.setAttribute('aria-expanded', 'false');
    if (isProducts) s.setAttribute('aria-controls', 'fll-mega-v2');
    items.push({ li: lis[i], details: d, summary: s, products: isProducts, openT: 0, closeT: 0 });
  }
  var prod = null;
  for (var k = 0; k < items.length; k++) if (items[k].products) prod = items[k];

  /* ----- Products panel: take over from the older hover script (trusted pointer events only) ----- */
  var hideT = 0;
  if (prod) {
    ['mouseenter', 'mouseleave', 'mouseover', 'mouseout'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        if (!e.isTrusted) return;
        var t = e.target;
        if (t !== prod.summary && t !== panel) return;
        e.stopPropagation(); // keeps the older script's at-target hover listeners from firing
        if (t === panel && canHover()) {
          if (type === 'mouseenter') clearTimeout(prod.closeT);
          else if (type === 'mouseleave') leave(prod);
        }
      }, true);
    });
  }
  function panelOpen() { return prod && !panel.hidden && panel.classList.contains('is-open'); }
  function showPanel() {
    clearTimeout(hideT);
    prod.details.open = false;
    panel.style.top = Math.max(0, header.getBoundingClientRect().bottom) + 'px';
    panel.hidden = false;
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    prod.summary.setAttribute('aria-expanded', 'true');
  }
  function hidePanel() {
    panel.classList.remove('is-open');
    prod.summary.setAttribute('aria-expanded', 'false');
    clearTimeout(hideT);
    hideT = setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 220);
  }

  function isOpen(it) { return it.products ? panelOpen() : it.details.open; }
  function open(it) {
    closeAll(it);
    if (it.products) { showPanel(); return; }
    if (!it.details.open) it.details.open = true;
    it.summary.setAttribute('aria-expanded', 'true');
  }
  function close(it) {
    clearTimeout(it.openT); clearTimeout(it.closeT);
    if (it.products) { if (!panel.hidden) hidePanel(); return; }
    if (it.details.open) it.details.open = false;
    it.summary.setAttribute('aria-expanded', 'false');
  }
  function closeAll(except) { for (var j = 0; j < items.length; j++) if (items[j] !== except) close(items[j]); }
  function anyOpen() { for (var j = 0; j < items.length; j++) if (isOpen(items[j])) return items[j]; return null; }

  function enter(it) {
    if (!canHover()) return;
    clearTimeout(it.closeT);
    if (isOpen(it)) return;
    clearTimeout(it.openT);
    // same 100 ms intent delay when switching, so a diagonal move toward an open panel
    // that clips a neighbouring item does not steal the dropdown
    it.openT = setTimeout(function () { open(it); }, OPEN_DELAY);
  }
  function leave(it) {
    if (!canHover()) return;
    clearTimeout(it.openT);
    clearTimeout(it.closeT);
    it.closeT = setTimeout(function () {
      // pointer is still over the item or its panel (boundary events can misfire on pseudo-element bridges)
      if (it.li.matches(':hover') || (it.products && panel.matches(':hover'))) return;
      close(it);
    }, CLOSE_DELAY);
  }

  items.forEach(function (it) {
    it.li.addEventListener('mouseenter', function () { enter(it); });
    it.li.addEventListener('mouseleave', function () { leave(it); });
    if (!it.products) {
      // native click/keyboard toggle: keep aria in sync and one-at-a-time
      it.details.addEventListener('toggle', function () {
        it.summary.setAttribute('aria-expanded', it.details.open ? 'true' : 'false');
        if (it.details.open) closeAll(it);
      });
    } else {
      it.summary.addEventListener('click', function () {
        // the older script toggles the panel on click; mirror aria + close siblings
        setTimeout(function () { var o = panelOpen() || !panel.hidden; prod.summary.setAttribute('aria-expanded', o ? 'true' : 'false'); if (o) closeAll(prod); }, 0);
      });
      it.summary.addEventListener('focus', function () { setTimeout(function () { if (!panel.hidden) closeAll(prod); }, 0); });
    }
  });
  if (prod) {
    panel.addEventListener('focusout', function (e) {
      if (!panel.contains(e.relatedTarget) && e.relatedTarget !== prod.summary) close(prod);
    });
  }

  /* A real pointer click on an item that hover already opened keeps it open (no open-then-close flicker).
     Keyboard activation (Enter/Space → click with detail 0) still toggles as before. */
  document.addEventListener('click', function (e) {
    if (!canHover() || !e.isTrusted || e.detail === 0) return;
    for (var j = 0; j < items.length; j++) {
      var it = items[j];
      if (!it.summary.contains(e.target)) continue;
      clearTimeout(it.openT); clearTimeout(it.closeT);
      if (isOpen(it)) { e.preventDefault(); e.stopPropagation(); return; }
      if (it.products) { e.preventDefault(); e.stopPropagation(); open(it); }
      return;
    }
  }, true);
  if (prod) {
    prod.summary.addEventListener('focusout', function (e) {
      var to = e.relatedTarget;
      if (to && nav.contains(to) && !prod.summary.contains(to)) close(prod);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var it = anyOpen(); if (!it) return;
    var inside = it.li.contains(document.activeElement) || (it.products && panel.contains(document.activeElement));
    close(it);
    if (inside) it.summary.focus({ preventScroll: true });
  });
})();
